var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.37959 23h18.25201c2.2381 0 3.3684-1.0966 3.3684-3.2354v-12.52917c0-2.13886-1.1303-3.23543-3.3684-3.23543h-18.25201c-2.23814 0-3.37959 1.08571-3.37959 3.23543v12.52917c0 2.1497 1.14145 3.2354 3.37959 3.2354zm-1.54432-15.656c0-1.04229.57073-1.57429 1.60027-1.57429h18.14006c1.0184 0 1.6003.532 1.6003 1.57429v2.51886h-21.34063zm17.67013 1.76971c.7274-.01085 1.3317-.59714 1.3317-1.292 0-.70571-.6043-1.30285-1.3317-1.30285-.7162 0-1.3317.59714-1.3317 1.30285 0 .69486.6155 1.31372 1.3317 1.292zm-17.67013 6.42739v-4.0822h21.34063v4.0822zm17.67013-.7708c.7274-.0109 1.3317-.5863 1.3317-1.292s-.6043-1.3029-1.3317-1.3029c-.7162 0-1.3317.5972-1.3317 1.3029s.6155 1.3137 1.3317 1.292zm-16.06986 6.4491c-1.02954 0-1.60027-.532-1.60027-1.5743v-2.4971h21.34063v2.4971c0 1.0423-.5819 1.5743-1.6003 1.5743zm16.06986-.7817c.7274-.0217 1.3317-.5971 1.3317-1.3028 0-.7058-.6043-1.3029-1.3317-1.3029-.7162 0-1.3317.5971-1.3317 1.3029 0 .7057.6155 1.3137 1.3317 1.3028z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.e76ce5f6.svg";
export { ForwardRef as ReactComponent };